import styles from "./CarsSummary.module.css";

const InactiveCarsSummary = ({ count }: { count: number }) => {
  return (
    <div className={styles.summaryMainContainer}>
      <div className={styles.summaryContainer} style={{ paddingBottom: "0px" }}>
        <div className={styles.summaryItem} >
          <div className={styles.summaryItemTitle}>סה"כ רכבים לא פעילים:</div>
          <div className={styles.summaryItemValue}>{count}</div>
        </div>
      </div>
      <div className={styles.smallDescription}>רכבים שלא הופיעו בקובץ אקסל המעודכן ב-29/04/2026 (לא ניתן לקבל קוד תדלוק להם)</div>
    </div>
  );
};

export default InactiveCarsSummary;
